import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserInformation } from "actions/user";
import RecommendedSteps from "pages/dashboard/RecommendedSteps";
import OrderSummary from "pages/dashboard/OrderSummary";
import OrderManage from "pages/dashboard/OrderManage";
import WarningIcon from "@material-ui/icons/Warning";
import Button from "components/Button";
import { getWebPage } from "actions/webPages";
import DashboardWebPage from "pages/web-pages/Dashboard";
import { useHistory } from "react-router-dom";
import { ROUTES } from "shared/constants/routes";
import ErrorMessage from "components/ErrorMessage";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import {
  Container,
  Heading,
  Error,
  ShirtlyUpdate,
  FulfillmentWrapper,
  ApprovedKyc,
} from "styles/pages/dashboard";

const Dashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const emailId = useSelector((state) => state?.auth?.profile?.emailid);
  const [user, setUser] = useState(undefined);
  const [dashboardData, setDashboardData] = useState();

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!user) {
        const request = await dispatch(getUserInformation(emailId));
        if (request?.error) {
          return;
        }
        setUser(request);
      }
    };
    fetchUserDetails();
  }, [dispatch, emailId, user]);

  useEffect(() => {
    const fetchData = async () => {
      const request = await dispatch(getWebPage({ page: "Dashboard" }));
      if (request?.error) {
        return;
      }
      setDashboardData(request);
    };
    if (!dashboardData) fetchData();
  }, [dispatch, dashboardData]);

  return (
    <Container>
      {/* <ErrorMessage className="error">
        <ApprovedKyc>
          <ReportProblemIcon />
          <b>BOT is under maintenance, please try again after sometime.</b>
        </ApprovedKyc>
      </ErrorMessage> */}

      {dashboardData && dashboardData?.length > 0 && (
        <DashboardWebPage data={dashboardData} isAdmin={false} />
      )}

      <Error>
        <ShirtlyUpdate>
          <WarningIcon />
          &nbsp;BIG OVEN TEES UPDATE
        </ShirtlyUpdate>
        <h2>
          If you wish to pay in Canadian dollars there is an option when you
          check out. We convert at current exchange rates.
        </h2>

        <div style={{ color: "red", fontWeight: "normal" }}>
          <b>Durasoft Decoration</b> Technique is discontinued for <b>Cotton</b>
          &nbsp;Products. It will remain available for <b>Polyester</b> products
          and some technical products such as Hats. Please ensure order accuracy
          at the time of order submission.
        </div>
        <br />

        <div style={{ color: "orange" }}>
          Orders submitted to Big Oven Tees as of now are subject to order
          processing times of 3 to 7 business days.
          <br />
          <br />
          Durasoft Decoration Fulfillment times: 8 – 12 business days.
          <br />
          <br />
          DTG Decoration Fulfillment times 3 – 7 business days.
          <br />
          <br />
          Due to global shortage, we are experiencing low supply of some SKUs.
          Our current inventory stock status for both fulfillment centres is as
          following:
          <br />
          <br />
        </div>
        <FulfillmentWrapper style={{ marginTop: 20 }}>
          <Button
            title="Check Live Inventory"
            containerStyle={{
              margin: "0 auto",
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "bold",
              padding: 15,
            }}
            onClick={() => history.push(ROUTES.INVENTORY.LINK)}
          />
        </FulfillmentWrapper>
        <div style={{ color: "orange" }}>
          From time to time, we may experience inventory shortages in other SKUs
          due to Covid-19 which may cause some minor delays in processing
          orders.
        </div>
        <br />
      </Error>
      <Heading>
        Welcome to your New Big Oven Tees App. Let's get you started.
      </Heading>
      <RecommendedSteps user={user} />

      {user?.User?.EmailConfirmed && (
        <React.Fragment>
          <OrderSummary user={user} />
          <OrderManage />
        </React.Fragment>
      )}
    </Container>
  );
};

export default Dashboard;
